import styled, { css } from 'styled-components';

import { ReactComponent as ArrowUp } from 'assets/icons/arrow-up.svg';
import { ReactComponent as DownArrow } from 'assets/icons/downArrow.svg';
import { SORT_DIR } from 'constants/constants';

export const TableWrapper = styled.div`
  display: grid;
  gap: 2.8rem;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  overflow-x: auto;
  transition: all 150ms ease-in-out;
  table {
    width: 100%;
  }
  th,
  td {
    padding: 0 1rem;
    width: fit-content;
  }
  min-height: 38rem;
  overflow: visible;
`;

export const ArrowColumn = styled.td`
  padding: 0;
  max-width: 3.9rem;
`;

export const ArrowIcon = styled(ArrowUp)`
  display: block;
  height: 1rem;
  transition: all 150ms ease-in-out;
  transform: ${({ direction }) =>
    direction === SORT_DIR.desc ? 'rotate(-180deg) translate(0, 10%)' : 'none'};
  width: 1.2rem;
  height: 1.2rem;
  opacity: ${({ $isSorting }) => ($isSorting ? '1' : '0.3')};
  path {
    stroke: ${({ theme, $isSorting }) =>
      $isSorting ? theme.new.colors.P500 : theme.new.colors.N900};
    stroke-width: 1.8px;
  }
`;

export const Table = styled.table`
  border-collapse: collapse;
  background: ${({ theme }) => theme.new.colors.white};
  height: fit-content;
`;

export const ArrowButton = styled(DownArrow)`
  margin-left: 0.8rem;
  transform: ${({ $isExpanded }) =>
    $isExpanded ? `scale(${20 / 24}) rotate(-180deg) translate(0, -25%)` : `scale(${20 / 24})`};
  transition: all 150ms ease-in-out;
  stroke: ${({ theme }) => theme.new.colors.N900};
  height: 1.8rem;
  width: 2rem;
  cursor: pointer;
  visibility: ${({ $hasAssignments }) => ($hasAssignments ? 'inherit' : 'hidden')};
`;

export const ExpandedRow = styled.tr`
  vertical-align: top;
  ${({ $isExpanded }) =>
    $isExpanded &&
    css`
      border-left: 3px solid ${({ theme }) => theme.new.colors.P500};
      border-bottom: 1px solid ${({ theme }) => theme.new.colors.N400};
    `};
  height: ${({ $isExpanded }) => ($isExpanded ? 'auto' : '0')};
  transition: all 1300ms ease-in-out;
  overflow: hidden;
  background-color: ${({ theme }) => theme.new.colors.N100};
`;

export const Column = styled.td`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  padding: ${({ padding }) => padding && `${padding} !important`};
`;

export const HeaderColumnContainer = styled.button`
  ${({ theme }) => theme.new.typography.p5SemiBold};
  align-items: center;
  color: ${({ theme }) => theme.new.colors.N900};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  font-size: 1.4rem;
  justify-content: start;
  width: fit-content;
`;

export const OptionsColumn = styled.th`
  opacity: ${({ $isExpanded }) => ($isExpanded ? '1' : '0')};
  cursor: auto;
`;

export const Row = styled.tr`
  background: ${({ $isExpanded, theme }) => ($isExpanded ? theme.new.colors.P100 : 'none')};
  border-bottom: 1px solid
    ${({ theme, isHeader }) => (isHeader ? theme.new.colors.N500 : theme.new.colors.N400)};
  height: ${({ height }) => height || '7.2rem'};
  text-align: left;
  width: 100%;
  &:hover {
    ${({ isHeader, $isExpanded, theme }) =>
      !isHeader &&
      css`
        background: ${$isExpanded ? theme.new.colors.P100 : theme.new.colors.N100};
        ${OptionsColumn} {
          opacity: 1;
        }
      `}
  }
  td:nth-child(2) {
    max-width: 30rem;
  }
`;
